/**
 * Formats a Date or date string into 'MM/DD/YYYY HH:mm' format.
 *
 * Example output: '10/09/2025 02:05 PM' for October 9, 2025, 02:05 PM.
 *
 * @param date - The date to format, as a Date object or string.
 * @returns The formatted date string, or an empty string if input is falsy.
 */
export function formatTime(date?: Date | string): string {
  if (!date) {
    return '';
  }

  const dateToFormat = date instanceof Date ? date : new Date(date);

  const month = String(dateToFormat.getMonth() + 1).padStart(2, '0'); // JS months are 0-based
  const day = String(dateToFormat.getDate()).padStart(2, '0');
  const year = dateToFormat.getFullYear();
  const minutes = String(dateToFormat.getMinutes()).padStart(2, '0');

  let hour = dateToFormat.getHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';

  hour = hour % 12;
  if (hour === 0) hour = 12;

  const hourStr = String(hour).padStart(2, '0');

  return `${month}/${day}/${year} ${hourStr}:${minutes} ${ampm}`;
}
